import { FormGroup, FormHelperText, InputLabel } from "@material-ui/core";
import { Button } from "@thrivetribe/gloji.ui.atoms.button";
import { ErrorMessage, Form, Formik } from "formik";
import React, { useEffect } from "react";
import { Helmet } from "react-helmet";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router";
import { update_signup_form_values } from "../../../../store/actions/signupFlowData";
import FormikInputOnly from "../../../atoms/formik-input-only";
import { FormikField } from "../../../atoms/FormikField";
import {
  ModalPageBody,
  ModalPageCopy,
  ModalPageFooter,
  ModalPageHeader,
  ModalPageHeading,
  ModalPageWrapper,
} from "../../../organisms/ModalPage";
import { IntroduceYourselfValidationSchema } from "../../../../data/Validation/EligibilityCheckerValidation";
import { pageTitleSuffix } from "../../../../data/eligibilityChecker";
import { ProgrammeProps } from "../Props";
import { PowerOfTen, ProgressStepEnum, setStepProgress } from "../../../../redux/slices/progressBarSlice";

interface IntroduceYourselfProps extends ProgrammeProps {
  profileFirstName?: string;
  profileLastName?: string;
  progressPercentage?: PowerOfTen;
}

const IntroduceYourself: React.FC<ProgrammeProps> = (props: IntroduceYourselfProps) => {
  const { programmeTitle, profileFirstName, profileLastName, progressPercentage } = props;
  const dispatch = useDispatch();
  const history = useHistory();

  const namePageData = useSelector(
    (state: any) => state.signupFlowData.signupPagesData?.["introduce-yourself"]
  );
  const signupFormValues = useSelector((state: any) => state.signupFlowData.signupFormValues);

  useEffect(() => {
    if (progressPercentage) {
      dispatch(
        setStepProgress({
          progressStepEnum: ProgressStepEnum.CheckEligiblity,
          progressPercentage: progressPercentage,
        })
      );
    }
  }, [dispatch, progressPercentage]);

  const initialValues = {
    firstName: signupFormValues?.firstName ?? profileFirstName ?? "",
    lastName: signupFormValues?.lastName ?? profileLastName ?? "",
  };
  const pageTitle = `Name | ${programmeTitle} | ${pageTitleSuffix}`;

  useEffect(() => {
    window.gtag("event", "page_view", {
      page_title: pageTitle,
    });
  }, []);

  const handleSubmit = values => {
    dispatch(update_signup_form_values(values));
    history.push("/contact-number");
  };

  return (
    <Formik
      initialValues={initialValues}
      onSubmit={handleSubmit}
      validationSchema={IntroduceYourselfValidationSchema}
      validateOnChange={false}
    >
      {({ errors, touched }) => {
        return (
          <Form className="eligibility-checker-form">
            <Helmet>
              <title> {pageTitle} </title>
            </Helmet>
            <ModalPageWrapper>
              <ModalPageBody hasStickyFooter={false}>
                <ModalPageHeader
                  backButtonOnClick={() => {
                    history.goBack();
                  }}
                />
                <ModalPageHeading>{namePageData?.questions[0].question}</ModalPageHeading>
                <ModalPageCopy>
                  <span style={{ marginTop: "15px", marginBottom: "20px" }}>
                    {namePageData?.questions[0].description}
                  </span>
                </ModalPageCopy>
                <FormGroup className="eligibility-checker__form-group">
                  <InputLabel htmlFor="firstName" className="eligibility-checker__input-label">
                    First name
                  </InputLabel>
                  <FormikField
                    id="firstName"
                    name="firstName"
                    className="eligibility-checker__text-input"
                    component={FormikInputOnly}
                  />
                  <ErrorMessage
                    key="firstName"
                    className="Mui-error"
                    name="firstName"
                    component={FormHelperText}
                  />
                </FormGroup>
                <FormGroup>
                  <InputLabel htmlFor="lastName" className="eligibility-checker__input-label">
                    Last name
                  </InputLabel>
                  <FormikField
                    id="lastName"
                    name="lastName"
                    className="eligibility-checker__text-input"
                    component={FormikInputOnly}
                  />
                  <ErrorMessage
                    key="lastName"
                    className="Mui-error"
                    name="lastName"
                    component={FormHelperText}
                  />
                </FormGroup>
              </ModalPageBody>
              <ModalPageFooter hasStickyFooter={false}>
                <Button type="submit" variant="contained" color="primary">
                  Continue
                </Button>
              </ModalPageFooter>
            </ModalPageWrapper>
          </Form>
        );
      }}
    </Formik>
  );
};

export default IntroduceYourself;
